import ToolShell, { OutputBlock } from "@/pages/tools/ToolShell";

export default function CaptionRewrite() {
  return (
    <ToolShell
      testid="tool-caption-page"
      eyebrow="Tool" toolKey="caption"
      title="Caption Rewrite"
      subtitle="Paste any caption. We rebuild it long-form using the DIL 8-step doctrine."
      endpoint="/tools/caption-rewrite"
      fields={[
        { key: "original", label: "Original caption", type: "textarea", rows: 6, required: true, placeholder: "Paste your existing caption here." },
        { key: "intent", label: "What do you want this post to do? (optional)", type: "text", placeholder: "e.g. Drive saves and follows from new divers" },
      ]}
      renderOutput={(o) => (
        <>
          <OutputBlock testid="output-diagnosis" label="Diagnosis">{o.diagnosis}</OutputBlock>
          <OutputBlock testid="output-rewritten" label={`Rewritten Caption (${(o.rewritten_caption || "").length} chars)`} copyValue={o.rewritten_caption}>
            <div className="whitespace-pre-wrap leading-relaxed">{o.rewritten_caption}</div>
          </OutputBlock>
          {o.improvements && (
            <OutputBlock testid="output-improvements" label="What changed">
              <ul className="list-disc pl-5 space-y-1.5">
                {o.improvements.map((b, i) => <li key={i}>{b}</li>)}
              </ul>
            </OutputBlock>
          )}
          <OutputBlock testid="output-cta" label="CTA" copyValue={o.cta}>{o.cta}</OutputBlock>
        </>
      )}
    />
  );
}
